<template>
    <v-container class="grey lighten-5" fluid>
        <v-row align="center" justify="center">
            <v-col md="10" sm="10" xs="12">
                <v-card>
                    <v-card-title class="px-3">Edit User</v-card-title>
                    <v-divider></v-divider>
                    
                    <v-form ref="form" lazy-validation>
                        <v-row class="px-4 py-4 pb-2">
                            <v-col md="6" sm="6" xs="6" class="pb-0 pt-4">
                                <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Search"
                                    clearable
                                    class="mt-0 pt-0"
                                    @change="getUsers"
                                    @click:clear="search = null; getUsers();"
                                ></v-text-field>
                            </v-col>

                            <v-col md="6" sm="6" xs="6" class="pb-0">
                                <v-autocomplete
                                    v-if="$store.getters.role <= 3"
                                    v-model="merchant"
                                    label="Select a merchant"
                                    :items="merchants"
                                    item-value="uuid"
                                    item-text="name"
                                    dense
                                    top
                                    :clearable="$store.getters.role <= 3"
                                    @change="getUsers"
                                ></v-autocomplete>
                                <v-select
                                    v-else
                                    v-model="merchant"
                                    label="Select a merchant"
                                    :items="merchants"
                                    item-value="uuid"
                                    item-text="name"
                                    dense
                                    top
                                    @change="getUsers"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="headers"
                            :items="users"
                            :items-per-page="10"
                        >
                            <template v-slot:item.edit="{ item }">
                                <v-btn @click="edit(item)" text icon color="grey">
                                    <v-icon color="grey" size="22">
                                        mdi-account-edit
                                    </v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>

        <edit
            :visible="dialog"
            :user="user"
            :merchants="merchants"
            :state="state"
            @close="dialog = $event"
            @update="getUsers"
            @disable="disableUser"
        ></edit>

        <v-snackbar
            v-model="snackbar.show"
            :timeout="snackbar.timeout"
            :color="snackbar.color"
        >
            {{ snackbar.text }}

            <template v-slot:action="{ attrs }">
            <v-btn
                color="white"
                text
                fab
                small
                v-bind="attrs"
                @click="snackbar.show = false"
            >
                <v-icon>mdi-close-circle</v-icon>
            </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import axios from 'axios';
import Edit from '@/components/users/Edit.vue';

export default {
    components: {
        'edit': Edit
    },
    beforeMount() {
        this.uri = this.state;
        this.getMerchants();
    },
    computed: {
        state() {
            return this.$store.state.sysState ? 'live' : 'test';
        }
    },
    watch: {
        state() {
            this.uri = this.state;
            this.getMerchants();
        }
    },
    data() {
        return {
            user: null,
            users: [],
            search: null,
            userRoles: null,
            merchant: null,
            merchants: [],
            result: false,
            dialog: false,
            uri: null,
            headers: [{ text: 'Username', value: 'username', sortable: false, align: 'left' },
                      { text: 'Email', value: 'email', sortable: false, align: 'left' },
                      { text: 'First Name', value: 'first_name', sortable: false, align: 'left' },
                      { text: 'Surname', value: 'surname', sortable: false, align: 'left' },
                      { text: 'Role', value: 'user_role_desc', sortable: false, align: 'left' },
                      { text: 'Created At', value: 'created_at', sortable: false, align: 'left' },
                      { text: 'Edit', value: 'edit', sortable: false, align: 'center' }],
            snackbar: {
                show: false,
                text: null,
                color: null,
                timeout: 5000,
            },
        }
    },
    methods: {
        getMerchants() {
            if(this.$store.getters.role <= 3) {
                axios({
                method: 'get',
                url: `get-merchants-${this.uri}`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                    this.getUsers();
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                axios({
                method: 'post',
                url: `get-merchants-${this.uri}-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                    this.merchant = this.merchants.length > 0 ? this.merchants[0].uuid : null;
                    this.getUsers();
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getUsers() {
            axios({
                method: 'post',
                url: `get-merchant-users`,
                data: { search: this.search,
                        userRole: this.$store.state.user.user_role.id,
                        merchant: this.merchant,
                        state: this.state },
                config: { headers: { 'Content-Type': 'application/json', 
                                     'Authorization': 'Bearer txtJsVbdp7NcraOGzNQcEVgyT02FzSO4yDy8t0zod9AVARTOBbPDYRQiLiIVB0xcJZKfnELxcHJk3uYP' }}
                })
                .then(response => {
                    this.users = response.data;
                    this.user = this.user ? response.data.find(e => e.id == this.user.id) : null;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        edit(e) {
            axios({
                method: 'post',
                url: `get-user`,
                data: { userId: e.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.user = e;
                    this.user.merchantUuid = this.state == 'live' ? response.data.merchant_access : response.data.merchant_access_test;
                    this.dialog = true;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        disableUser(e) {
            // Hide the edit dialogue
            this.dialog = false;

            // Refresh user list
            this.getUsers();

            // Show alert with message
            this.snackbar = {
                show: true,
                text: e.message,
                color: 'primary',
                timeout: 5000,
            };
        }
    }
}
</script>

<style>
.v-select.v-input--dense .v-chip {
    margin: 4px 4px 4px 4px !important;
}
</style>